'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RightElement;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonIcon = require('../ButtonIcon');

var _ButtonIcon2 = _interopRequireDefault(_ButtonIcon);

var _closeIcon = require('./icons/closeIcon');

var _closeIcon2 = _interopRequireDefault(_closeIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function RightElement(_ref) {
  var showCloseButton = _ref.showCloseButton,
      onClear = _ref.onClear,
      icon = _ref.icon;

  if (showCloseButton) {
    return _react2["default"].createElement('span', {
      className: 'rainbow-lookup_input-close-button-container'
    }, _react2["default"].createElement(_ButtonIcon2["default"], {
      assistiveText: 'close',
      size: 'small',
      title: 'close',
      tabIndex: -1,
      icon: _react2["default"].createElement(_closeIcon2["default"], null),
      onClick: onClear
    }));
  }

  return _react2["default"].createElement('span', {
    className: 'rainbow-lookup_input-icon'
  }, icon);
}

RightElement.propTypes = {
  icon: _propTypes2["default"].node,
  showCloseButton: _propTypes2["default"].bool,
  onClear: _propTypes2["default"].func
};
RightElement.defaultProps = {
  icon: undefined,
  showCloseButton: false,
  onClear: function onClear() {}
};